import { useParams } from '@tanstack/react-router';
import { PurchaseOrderActivity } from '@/features/purchase-order/purchase-order-activity';

export function PurchaseOrderActivityPage() {
  const { id } = useParams({ strict: false });

  return <PurchaseOrderActivity purchaseOrderId={`${id}`} />;
}
